export default {
    routerName: '部門管理',
    dept: {
        searchName: '検索条件',
        name: '部門名',
        leader: '責任者',
        mobile: '携帯電話',
        email: 'メール',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
    },
    table: {
        id: 'ID',
        name: '部門',
        sortOrder: 'ソート',
        leader: '責任者',
        createBy: '作成者',
        createTime: '作成日付',
        status: '状態',
    },
};
